/* TWD product options: same-product bundle tiers (Buy 2 / Buy 3 of this product), add to cart. Color/size tiles are plain links to sibling products. */
(function () {
  var SCROLL_KEY = 'twd-opt-scroll';

  function fmt(cents, currency) {
    var v = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: v % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(v);
    } catch (e) {
      return '$' + (v % 1 === 0 ? v : v.toFixed(2));
    }
  }

  function init(root) {
    if (root.dataset.twdReady) return;
    root.dataset.twdReady = '1';

    var data = [];
    try {
      data = JSON.parse(root.querySelector('[data-twd-data]').textContent).items;
    } catch (e) {}
    var currency = root.dataset.currency;
    var sizes = [];
    data.forEach(function (d) {
      if (d.s && sizes.indexOf(d.s) === -1) sizes.push(d.s);
    });
    var pct = { 1: 0, 2: Number(root.dataset.pct2) || 0, 3: Number(root.dataset.pct3) || 0 };
    var curColor = root.dataset.curColor;
    var curSize = root.dataset.curSize;
    var curId = Number(root.dataset.curId);

    function find(color, size) {
      for (var i = 0; i < data.length; i++) if (data[i].c === color && data[i].s === size) return data[i];
      return null;
    }
    var colors = [];
    data.forEach(function (d) {
      if (colors.indexOf(d.c) === -1) colors.push(d.c);
    });

    var qtyInput = root.querySelector('[data-twd-qty]');
    var qtyWrap = root.querySelector('[data-twd-qtywrap]');
    var atc = root.querySelector('[data-twd-atc]');
    var errBox = root.querySelector('[data-twd-error]');
    var bundles = [].slice.call(root.querySelectorAll('[data-twd-bundle]'));
    var tier = 1;

    // selections for tiers 2 and 3: [{c, s}]
    var picks = { 2: [], 3: [] };
    [2, 3].forEach(function (n) {
      for (var i = 0; i < n; i++) picks[n].push({ c: curColor, s: curSize });
    });

    function qty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      return q > 0 ? q : 1;
    }

    function fillRow(n, i, row) {
      var cs = row.querySelector('[data-role="color"]');
      var ss = row.querySelector('[data-role="size"]');
      var p = picks[n][i];
      cs.innerHTML = '';
      colors.forEach(function (c) {
        var any = sizes.some(function (s) {
          return find(c, s);
        });
        var ok = sizes.some(function (s) {
          var d = find(c, s);
          return d && d.ok;
        });
        var o = document.createElement('option');
        o.value = c;
        o.textContent = c + (ok ? '' : ' (sold out)');
        o.disabled = !ok && c !== p.c;
        if (c === p.c) o.selected = true;
        if (any) cs.appendChild(o);
      });
      ss.innerHTML = '';
      cs.hidden = colors.length < 2;
      ss.hidden = sizes.length < 2;
      sizes.forEach(function (s) {
        var d = find(p.c, s);
        if (!d) return;
        var o = document.createElement('option');
        o.value = s;
        o.textContent = s + (d.ok ? '' : ' (sold out)');
        o.disabled = !d.ok && s !== p.s;
        if (s === p.s) o.selected = true;
        ss.appendChild(o);
      });
    }

    function itemsFor(n) {
      if (n === 1) {
        var d = find(curColor, curSize);
        return d ? [d] : [];
      }
      // Buy 2 / Buy 3 means 2 or 3 of this same product (the discount only applies to repeats of one product)
      var cur = find(curColor, curSize);
      var out = [];
      for (var k = 0; k < n; k++) out.push(cur);
      return out;
    }

    function render() {
      bundles.forEach(function (card) {
        var n = Number(card.dataset.twdBundle);
        var items = itemsFor(n);
        var sum = 0;
        var was = 0;
        items.forEach(function (d) {
          if (!d) return;
          sum += d.price;
          was += d.was > d.price ? d.was : d.price;
        });
        if (n === 1) {
          sum *= qty();
          was *= qty();
        }
        var total = Math.round(sum * (1 - pct[n] / 100));
        card.querySelector('[data-total]').textContent = fmt(total, currency);
        var wasEl = card.querySelector('[data-was]');
        if (was > total) {
          wasEl.textContent = fmt(was, currency);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      });
      if (qtyWrap) qtyWrap.hidden = tier !== 1;
      var sp = root.querySelector('[data-twd-shoppay]');
      if (sp) {
        sp.hidden = tier !== 1;
        var spq = sp.querySelector('[data-twd-sp-qty]');
        if (spq) spq.value = qty();
      }
    }

    function setTier(n) {
      tier = n;
      bundles.forEach(function (card) {
        var on = Number(card.dataset.twdBundle) === n;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    }

    // build item rows
    bundles.forEach(function (card) {
      var n = Number(card.dataset.twdBundle);
      if (n < 2) return;
      var itemsBox = card.querySelector('.twd-bundle__items');
      if (itemsBox && colors.length < 2 && sizes.length < 2) itemsBox.hidden = true;
      [].slice.call(card.querySelectorAll('[data-twd-row]')).forEach(function (row, i) {
        fillRow(n, i, row);
        row.addEventListener('change', function (e) {
          var p = picks[n][i];
          if (e.target.dataset.role === 'color') {
            p.c = e.target.value;
            if (!find(p.c, p.s) || !find(p.c, p.s).ok) {
              for (var k = 0; k < sizes.length; k++) {
                var cand = find(p.c, sizes[k]);
                if (cand && cand.ok) {
                  p.s = sizes[k];
                  break;
                }
              }
            }
          } else {
            p.s = e.target.value;
          }
          fillRow(n, i, row);
          render();
        });
      });
    });

    bundles.forEach(function (card) {
      var n = Number(card.dataset.twdBundle);
      card.addEventListener('click', function (e) {
        if (e.target.closest('select, option')) return;
        setTier(n);
      });
      card.addEventListener('keydown', function (e) {
        if (e.target !== card) return;
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          setTier(n);
        }
      });
    });

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b || !qtyInput) return;
      var q = Math.min(99, Math.max(1, qty() + Number(b.dataset.qty)));
      qtyInput.value = q;
      render();
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', function () {
        qtyInput.value = qty();
        render();
      });
    }

    // keep scroll position when a tile or pill navigates to a sibling product
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-twd-nav]');
      if (!a) return;
      try {
        sessionStorage.setItem(SCROLL_KEY, JSON.stringify({ y: window.scrollY, t: Date.now() }));
      } catch (err) {}
    });

    function showError(msg) {
      if (!errBox) return;
      errBox.textContent = msg || '';
      errBox.hidden = !msg;
    }

    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.getAttribute('aria-disabled') === 'true') return;
        showError('');
        var lines = {};
        if (tier === 1) {
          lines[curId] = qty();
        } else {
          lines[curId] = tier;
        }
        var items = Object.keys(lines).map(function (id) {
          return { id: Number(id), quantity: lines[id] };
        });
        if (!items.length) return;

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        atc.setAttribute('aria-disabled', 'true');
        fetch(window.routes.cart_add_url.replace(/\.js$/, '') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (res.status) {
              showError(res.description || res.message || 'Could not add to cart.');
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!res.key && res.items && res.items[0]) res.key = res.items[0].key;
            if (!res.id && res.items && res.items[0]) res.id = res.items[0].id;
            try {
              if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'twd-options', productVariantId: items[0].id, cartData: res });
              }
            } catch (err) {}
            cart.renderContents(res);
          })
          .catch(function () {
            showError('Network error. Please try again.');
          })
          .finally(function () {
            atc.removeAttribute('aria-disabled');
          });
      });
    }

    render();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-twd-opt]')).forEach(init);
    try {
      var s = JSON.parse(sessionStorage.getItem(SCROLL_KEY) || 'null');
      sessionStorage.removeItem(SCROLL_KEY);
      if (s && Date.now() - s.t < 15000) window.scrollTo(0, s.y);
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
